import type { TutorAttendanceRateBooking } from './interfaces'

import { AppRoute } from '@shared/config'
import { useAdminRoutes } from '@shared/lib/routes'
import { resolveUrl } from '@shared/lib/url'

export const getLessonUrl = (booking: TutorAttendanceRateBooking): string =>
  resolveUrl(AppRoute.LessonsEdit, { id: booking.discipline_id, lessonId: booking.id }) ?? ''

/** Tutors are not migrated yet: link to app-main, as the legacy list did. */
export const getTutorUrl = (tutorId: number): string =>
  useAdminRoutes('admin.tutor.show', { tutor_id: tutorId }) ?? ''
